import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = 0,
    tableId = 0,
    name = '',
    type = '',
    defValue,
    editor = '',
    required = false,
    queryFilter = true,
    visible = true,
    options = {},
    validate = {},
    fdOrder = 0,
}, fetchOptions = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utable.saveField, {
        id: Number.parseInt(id, 0) || 0,
        tableId: Number.parseInt(tableId, 0) || 0,
        name,
        type,
        defValue,
        editor,
        required,
        queryFilter,
        visible,
        options,
        validate,
        fdOrder,
    }, fetchOptions);
    if (error) return { error, status };
    return content || {};
};
